/* eslint-disable no-await-in-loop */
import config from '@config';
import { DEFAULT_LOCALE } from '@constants';

import createDataSource from '../createDataSource';
import { getDefaultEmptyList } from '../utils';

const BASE_PATHNAME = 'rules';

export default () => {
  const dataSource = createDataSource(`${config.api.url}`);

  const getById = ({ id, locale }) => dataSource.get(`${BASE_PATHNAME}/${id}/${locale}`).json();

  const refetchRule = async ({ id, locale }) => {
    try {
      return await getById({ id, locale });
    } catch (e) {
      if (locale !== DEFAULT_LOCALE) {
        const refetchedRule = await getById({ id, locale: DEFAULT_LOCALE });
        return refetchedRule;
      }

      throw e;
    }
  };

  const getByIds = async ({ ids, locale, withFallback }) => {
    if (!withFallback) return Promise.all(ids.map((id) => getById({ id, locale })));

    return Promise.all(ids.map((id) => refetchRule({ id, locale })));
  };

  const create = ({ parentSectionId, values, locale }) =>
    dataSource.post(`${BASE_PATHNAME}`, { json: { ...values, parentSectionId, locale } }).json();
  const update = ({ parentSectionId, id, values, locale }) =>
    dataSource.put(`${BASE_PATHNAME}/${locale}`, { json: { ...values, parentSectionId, locale, id } }).json();
  const upsert = (options) => (options.id ? update(options) : create(options));
  const publish = async (options) => {
    const rule = await upsert(options);
    return dataSource.put(`${BASE_PATHNAME}/${rule.id}/${options.locale}/publish`).json();
  };
  const unpublish = ({ id }) => dataSource.put(`${BASE_PATHNAME}/${id}/unpublish`).json();
  return {
    getById,
    getByIds,
    create,
    update,
    upsert,
    publish,
    unpublish,
    getEmptyList: getDefaultEmptyList,
  };
};
